export type StoreListener<T> = (state: Readonly<T>, previous: Readonly<T>) => void;

export interface Store<T> {
  get(): Readonly<T>;
  set(update: Partial<T> | ((state: Readonly<T>) => Partial<T>)): void;
  subscribe(listener: StoreListener<T>): () => void;
}

export function createStore<T extends object>(initialState: T): Store<T> {
  let state: Readonly<T> = Object.freeze({ ...initialState });
  const listeners = new Set<StoreListener<T>>();

  return {
    get: () => state,
    set(update) {
      const patch = typeof update === "function" ? update(state) : update;
      const previous = state;
      state = Object.freeze({ ...state, ...patch });
      for (const listener of listeners) listener(state, previous);
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}
